// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z6Ms","delete":"styles_delete__3Hn2a","update":"styles_update__2XMLv","add":"styles_add__3zhK0"};